var SuperAdminLogindata = {
  id: "2898214",
  migratedId: "601275009fe9b971151e33b2",
  user_token: "EIF_798efffdb08e301888d910f87fedaed2",
  editor_lang: "en",
  user_type: "superadmin",
  username: "",
  avatar: "",
  first_name: "harshala",
  last_name: "gorale",
  user_email: "niharika@example.com",
  country_code: "91",
  user_mobile: "9713012989",
  lang_pref: "en",
  school_id: 1,
  grade_name: "10",
  grade_id: 0,
  board_name: "CBSE",
  board_id: 7,
  entitlements: ["ALL", "Chapter:[<ID's of Chapter>]"],
  school: {
    id: 1,
    name: "Eduisfun",
    schoolChainId: 344,
    whitelabelling_enabled: "false",
    logo: "",
    activatedBoards: [
      {
        name: "CBSE",
        activatedGrades: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
        ],
      },
      {
        name: "ICSE",
        activatedGrades: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
        ],
      },
      {
        name: "SSC",
        activatedGrades: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
        ],
      },
      {
        name: "OTHERS",
        activatedGrades: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
        ],
      },
    ],
    openRegistration: "true",
    activatedLanguages: ["en"],
    activatedProducts: ["concepts", "scholarship", "news", "funzone"],
    unlockedProducts: ["concepts", "scholarship", "news", "funzone"],
    implementationModel: "normal",
  },
  config: {
    allowUsage: "true",
    searchEnable: "true",
    searchText: "",
    cta: {
      type: "UPDATE",
      message: "Update Available. Please click to download",
      meta: "http://url_to_download",
    },
    reverseLayout: "true",
    islandBehaviour: "open",
    tabSequence: ["Concepts", "Profile", "More"],
  },
  version_code: "2.0",
  knowledge_wealth: 0,
  knowledge_currency: 0,
  learning_currency: 0,
  subjectDetails: [],
  totalAssessments: 0,
  assessmentDetails: [],
  picture: {
    _id: "606bed216a9f9d7720bc9fb2",
    name: "Screenshot (6).png",
    author: "601275009fe9b971151e33b2",
    size: 201146,
    shield:
      "sgod0qa7rnd2unsuq77yl196hekefo6nnlfkdv5bfl7xqc2qk502evhz30idj6tpfmjgek1qagdt5rm9i0jiposw4nw9ogirt7vt7iswcpayyfx3avf8gb5g",
    __v: 0,
    location:
      "./data/601275009fe9b971151e33b2/sgod0qa7rnd2unsuq77yl196hekefo6nnlfkdv5bfl7xqc2qk502evhz30idj6tpfmjgek1qagdt5rm9i0jiposw4nw9ogirt7vt7iswcpayyfx3avf8gb5g606bed216a9f9d7720bc9fb2.jpg",
    shieldedID:
      "sgod0qa7rnd2unsuq77yl196hekefo6nnlfkdv5bfl7xqc2qk502evhz30idj6tpfmjgek1qagdt5rm9i0jiposw4nw9ogirt7vt7iswcpayyfx3avf8gb5g606bed216a9f9d7720bc9fb2",
  },
};

var TeacherLogindata = {
  id: "2898214",
  migratedId: "601275009fe9b971151e33b2",
  user_token: "EIF_798efffdb08e301888d910f87fedaed2",
  editor_lang: "en",
  user_type: "teacher",
  username: "",
  avatar: "",
  first_name: "harshala",
  last_name: "gorale",
  user_email: "niharika@example.com",
  country_code: "91",
  user_mobile: "7771003014",
  lang_pref: "en",
  school_id: 1575,
  grade_name: "6",
  grade_id: "5e8c420b0325791cf604590b",
  subjectId: "5e9d9c5f2c2be8a25f9af405",
  board_name: "CBSE",
  entitlements: ["ALL", "Chapter:[<ID's of Chapter>]"],
  school: {
    id: 1575,
    name: "Eduisfun",
    schoolChainId: 344,
    whitelabelling_enabled: "false",
    logo: "",
    activatedBoards: [
      {
        name: "CBSE",
        activatedGrades: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
        ],
      },
      {
        name: "ICSE",
        activatedGrades: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
        ],
      },
      {
        name: "SSC",
        activatedGrades: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
        ],
      },
      {
        name: "OTHERS",
        activatedGrades: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
        ],
      },
    ],
    openRegistration: "true",
    activatedLanguages: ["en"],
    activatedProducts: ["concepts", "scholarship", "news", "funzone"],
    unlockedProducts: ["concepts", "scholarship", "news", "funzone"],
    implementationModel: "normal",
  },
  config: {
    allowUsage: "true",
    searchEnable: "true",
    searchText: "",
    cta: {
      type: "UPDATE",
      message: "Update Available. Please click to download",
      meta: "http://url_to_download",
    },
    reverseLayout: "true",
    islandBehaviour: "open",
    tabSequence: ["Concepts", "Profile", "More"],
  },
  version_code: "2.0",
  knowledge_wealth: 0,
  knowledge_currency: 0,
  learning_currency: 0,
  subjectDetails: [],
  totalAssessments: 0,
  assessmentDetails: [],
  picture: {
    _id: "606bed216a9f9d7720bc9fb2",
    name: "Screenshot (6).png",
    author: "601275009fe9b971151e33b2",
    size: 201146,
    shield:
      "sgod0qa7rnd2unsuq77yl196hekefo6nnlfkdv5bfl7xqc2qk502evhz30idj6tpfmjgek1qagdt5rm9i0jiposw4nw9ogirt7vt7iswcpayyfx3avf8gb5g",
    __v: 0,
    location:
      "./data/601275009fe9b971151e33b2/sgod0qa7rnd2unsuq77yl196hekefo6nnlfkdv5bfl7xqc2qk502evhz30idj6tpfmjgek1qagdt5rm9i0jiposw4nw9ogirt7vt7iswcpayyfx3avf8gb5g606bed216a9f9d7720bc9fb2.jpg",
    shieldedID:
      "sgod0qa7rnd2unsuq77yl196hekefo6nnlfkdv5bfl7xqc2qk502evhz30idj6tpfmjgek1qagdt5rm9i0jiposw4nw9ogirt7vt7iswcpayyfx3avf8gb5g606bed216a9f9d7720bc9fb2",
  },
};

var PrincipalLogindata = {
  id: "2898214",
  migratedId: "601275009fe9b971151e33b2",
  user_token: "EIF_798efffdb08e301888d910f87fedaed2",
  editor_lang: "en",
  user_type: "principal",
  username: "",
  avatar: "",
  first_name: "harshala",
  last_name: "gorale",
  user_email: "niharika@example.com",
  country_code: "91",
  user_mobile: "7771003014",
  lang_pref: "en",
  school_id: 1575,
  grade_name: "6",
  grade_id: "5e8c420b0325791cf604590b",
  subjectId: "5e9d9c5f2c2be8a25f9af405",
  board_name: "CBSE",
  entitlements: ["ALL", "Chapter:[<ID's of Chapter>]"],
  school: {
    id: 1575,
    name: "Eduisfun",
    schoolChainId: 344,
    whitelabelling_enabled: "false",
    logo: "",
    activatedBoards: [
      {
        name: "CBSE",
        activatedGrades: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
        ],
      },
      {
        name: "ICSE",
        activatedGrades: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
        ],
      },
      {
        name: "SSC",
        activatedGrades: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
        ],
      },
      {
        name: "OTHERS",
        activatedGrades: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
        ],
      },
    ],
    openRegistration: "true",
    activatedLanguages: ["en"],
    activatedProducts: ["concepts", "scholarship", "news", "funzone"],
    unlockedProducts: ["concepts", "scholarship", "news", "funzone"],
    implementationModel: "normal",
  },
  config: {
    allowUsage: "true",
    searchEnable: "true",
    searchText: "",
    cta: {
      type: "UPDATE",
      message: "Update Available. Please click to download",
      meta: "http://url_to_download",
    },
    reverseLayout: "true",
    islandBehaviour: "open",
    tabSequence: ["Concepts", "Profile", "More"],
  },
  version_code: "2.0",
  knowledge_wealth: 0,
  knowledge_currency: 0,
  learning_currency: 0,
  subjectDetails: [],
  totalAssessments: 0,
  assessmentDetails: [],
  picture: {
    _id: "606bed216a9f9d7720bc9fb2",
    name: "Screenshot (6).png",
    author: "601275009fe9b971151e33b2",
    size: 201146,
    shield:
      "sgod0qa7rnd2unsuq77yl196hekefo6nnlfkdv5bfl7xqc2qk502evhz30idj6tpfmjgek1qagdt5rm9i0jiposw4nw9ogirt7vt7iswcpayyfx3avf8gb5g",
    __v: 0,
    location:
      "./data/601275009fe9b971151e33b2/sgod0qa7rnd2unsuq77yl196hekefo6nnlfkdv5bfl7xqc2qk502evhz30idj6tpfmjgek1qagdt5rm9i0jiposw4nw9ogirt7vt7iswcpayyfx3avf8gb5g606bed216a9f9d7720bc9fb2.jpg",
    shieldedID:
      "sgod0qa7rnd2unsuq77yl196hekefo6nnlfkdv5bfl7xqc2qk502evhz30idj6tpfmjgek1qagdt5rm9i0jiposw4nw9ogirt7vt7iswcpayyfx3avf8gb5g606bed216a9f9d7720bc9fb2",
  },
};

export { SuperAdminLogindata, TeacherLogindata, PrincipalLogindata };
